module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("CHAPTER I")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Slowly, amidst intolerable noises from, on the one hand the street and, on the other, from the large and voluminously echoing playground, the depths of the telephone began, for Valentine, to assume an aspect that, years ago it had used to have—of being a part of the supernatural paraphernalia of inscrutable Destiny.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The telephone, for some ingeniously torturing reason was in a corner of the great schoolroom without any protection and, called imperatively, at a moment of considerable suspense, out of the asphalte playground where, under her command ranks of girls had stood electrically only just within the margin of control, Valentine with the receiver at her ear was plunged immediately into incomprehensible news uttered by a voice that she seemed half to remember. Right in the middle of a sentence it hit her:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“….that he ought presumably to be under control, which you mightn’t like!”; after that the noise burst out again and rendered the voice inaudible.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It occurred to her that probably at that minute the whole population of the world needed to be under control; she knew she herself did. But she had no male relative that the verdict could apply to in especial. Her brother? But he was on a mine-sweeper. In dock at the moment. And now … safe for good! There was also an aged great uncle that she had never seen. Dean of somewhere … Hereford? Exeter? … Somewhere…. Had she just said ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("safe")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("? She was shaken with joy!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She said into the mouthpiece:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Valentine Wannop speaking…. Physical Instructress at this school, you know!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She had to present an appearance of sanity … a sane voice at the very least!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The tantalisingly half-remembered voice in the telephone now got in some more incomprehensibilities. It came as if from caverns and as if with exasperated rapidity it exaggerated it’s “s”‘s with an effect of spitting vehemence.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“His brothers.s.s got pneumonia, so his mistress.ss.ss even is unavailable to look after….”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The voice disappeared; then it emerged again with:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“They’re said to be friends now!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It was drowned then, for a long period in a sea of shrill girl’s voices from the playground, in an ocean of factory-hooters’ ululations, amongst innumerable explosions that trod upon one another’s heels. From where on earth did they get explosives, the population of squalid suburban streets amidst which the school lay? For the matter of that where did they get the spirits to make such an appalling row? Pretty drab people! Inhabiting liver-coloured boxes. Not on the face of it an imperial race.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The sibilating voice in the telephone went on spitting out spitefully that the porter said he had no furniture at all; that he did not appear to recognise the porter…. Improbable sounding pieces of information half-extinguished by the external sounds but uttered in a voice that seemed to mean to give pain by what it said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Nevertheless it was impossible not to take it gaily. The thing, out there, miles and miles away must have been signed—a few minutes ago. She imagined along an immense line sullen and disgruntled cannon sounding for a last time.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I haven’t,” Valentine Wannop shouted into the mouthpiece, “the least idea of what you want or who you are.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She got back a title…. Lady someone or other. … It might have been Blastus. She imagined that one of the lady governoresses of the school must be wanting to order something in the way of school sports organised to celebrate the auspicious day. A lady governoress or other was always wanting something done by the School to celebrate something. No doubt the Head who was not wanting in a sense of humour—not ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("absolutely")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("wanting!—had turned this lady of title on to Valentine Wannop after having listened with patience to her for half an hour. The Head had certainly sent out to where in the playground they all had stood breathless, to tell Valentine Wannop that there was someone on the telephone that she—Miss Wanostrocht, the said Head—thought that she, Miss Wannop, ought to listen to. …. Then: Miss Wanostrocht must have been able to distinguish what had been said by the now indistinguishable lady of title. But of course that had been ten minutes ago … Before the maroons or the sirens, whichever it had been, had sounded…. “The porter said he had no furniture at all…. He did not appear to recognise the porter…. Ought presumably to be under control!” … Valentine’s mind thus recapitulated the information that she had from Lady (provisionally) Blastus. She imagined now that the Lady must be concerned for the superannuated drill-sergeant the school had had before it had acquired her, Valentine, as physical instructor. She figured to herself the venerable, mumbling gentleman, with several ribbons on a black commissionaire’s tunic. In an almshouse, probably. Placed there by the Governors of the school. Had pawned his furniture no doubt….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Intense heat possessed Valentine Wannop. She imagined indeed her eyes flashing. Was this the moment?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She didn’t even know whether what they had let off had been maroons or aircraft guns or sirens. It had happened—the noise, whatever it was—whilst she had been coming through the underground passage from the playground to the schoolroom to answer this wicked telephone. So she had not heard the sound. She had missed the sound for which the ears of a world had waited for years, for a generation. For an eternity. No sound. When she had left the playground there had been dead silence. All waiting: girls rubbing one ankle with the other rubber sole….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then…. For the rest of her life she was never to be able to remember the greatest stab of joy that had ever been known by waiting millions. There would be no one but she who would not be able to remember that…. Probably a stirring of the heart that was like a stab; probably a catching of the breath that was like an inhalation of flame! … It was over now; they were by now in a situation; a condition, something that would affect certain things in certain ways….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She remembered that the putative ex-drill sergeant had a brother who had pneumonia and thus an unavailable mistress….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She was about to say to herself:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“That’s just my luck!” when she remembered good-humouredly that her luck was not like that at all. On the whole she had had good luck—ups and downs. A good deal of anxiety at one time—but who hadn’t had! But good health; a mother with good health; a brother safe…. Anxieties, yes! But nothing that had gone so very wrong….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("This then was an exceptional stroke of bad luck! Might it be no omen—to the effect that things in future ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("would")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" go wrong: to the effect that she would miss other universal experiences. Never marry, say; or never know the joy of childbearing: if it was a joy! Perhaps it was; perhaps it wasn")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’t. One said one thing, one another. At any rate might it not be an omen that she would miss some universal and necessary experience! … Never see Carcassonne, the French said…. Perhaps she would never see the Mediterranean. You could not be a proper man if you had never seen the Mediterranean: the sea of Tibullus, of the Anthologists, of Sappho, even…. Blue: incredibly blue!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("People would be able to travel now. It was incredible! Incredible! Incredible! But you ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("could")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(". Next week you would be able to! You could call a taxi? And go to Charing Cross! And have a porter! A whole porter! … The wings, the wings of a dove: then would I flee away, flee away and eat pomegranates beside an infinite wash tub of Reckitt’s blue. Incredible, but you ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("could")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She felt eighteen again. Cocky! She said, using the good, metallic, Cockney bottoms of her lungs that she had used for shouting back at interrupters at Suffrage meetings before…. before this … she shouted blatantly into the telephone:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I say, whoever you are! I suppose they have ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("done")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" it; did they announce it in your parts by maroons or sirens?")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("” She repeated it three times, she did not care for Lady Blastus or Lady Blast Anybody else. She was going to leave that old school and eat pomegranates in the shadow of the rock where Penelope, wife of Ulysses, did her washing. With lashings of blue in the water! Was all your underlinen bluish in those parts owing to the colour of the sea? She could! She could! She ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("could")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("! Go with her mother and brother and all to where you could eat … Oh new potatoes! In December, the sea being blue…. ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("What songs the Sirens sang and whether")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She was not going to show respect for any Lady anything ever again. She had had to hitherto, independent young woman of means though she were, so as not to damage the School and Miss Wanostrocht with the Governoresses. Now … She was never going to show respect for anyone ever again. She had been through the mill: the whole world had been through the mill! No more respect!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As she might have expected she got it in the neck immediately afterwards—for over cockiness!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The hissing, bitter voice from the telephone enunciated the one address she did not want to hear:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Lincolnss..s.s….sInn!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Sin! … Like the Devil!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It hurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The cruel voice said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I’m s.s.peaking from there!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Valentine said courageously:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Well; it’s a great day. I suppose you’re bothered by the cheering like me. I can’t hear what you want. I don’t care. Let ‘em cheer!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She felt like that. She should not have.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The voice said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You remember your Carlyle….”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It was exactly what she did not want to hear. With the receiver hard at her ear she looked round at the great schoolroom—the Hall, made to let a thousand girls sit silent while the Head made the speeches that were the note of the School. Repressive! … The place was like a noncomformist chapel. High, bare walls with Gothic windows running up to a pitch-pine varnished roof. Repression, the note of the place; the place, the very place not to be in to-day…. You ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ought")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" to be in the streets, hitting policemen")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’s helmets with bladders. This was Cockney London: that was how Cockney London expressed itself. Hit policemen innocuously because policemen were stiff, embarrassed at these tributes of affection, swayed in rejoicing mobs over whose heads they looked remotely, like poplar trees jostled by vulgarer vegetables!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But she was there, being reminded of the dyspepsia of Thomas Carlyle!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Oh!")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(",” she exclaimed into the instrument, “You’re Edith Ethel!” Edith Ethel Duchemin, now of course Lady Macmaster! But you weren’t used to thinking of her as Lady Somebody.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The last person in the world: the very last! Because, long ago she had made up her mind that it was all over between herself and Edith Ethel. She certainly could not make any advance to the ennobled personage who vindictively disapproved of all things made—with a black thought in a black shade, as you might say. Of all things that were not being immediately useful to Edith Ethel!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("And, æsthetically draped and meagre, she had sets of quotations for appropriate occasions. Rossetti for Love; Browning for optimism—not frequent that: Walter Savage Landor to show acquaintance with more esoteric prose. And the unfailing quotation from Carlyle for damping off saturnalia: for New Year’s Day, Te Deums, Victories, anniversaries, celebrations…. It was coming over the wire now, that quotation:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“….And then I remembered that it was the birthday of their Redeemer!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("How well Valentine knew it: how often with spiteful conceit had not Edith Ethel intoned that. A passage from the diary of the Sage of Chelsea who lived near the Barracks.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“To-day,” the quotation ran, “I saw that the soldiers by the public house at the corner were more than usually drunk. And then I remembered that it was the birthday of their Redeemer!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("How superior of the Sage of Chelsea not to remember till then that that had been Christmas Day! Edith Ethel, too, was trying to shew how superior she was. She wanted to prove that until she, Valentine Wannop, had reminded her, Lady Macmaster, that that day had about it something of the popularly festival she, Lady Mac, had been unaware of the fact. Really quite unaware, you know. She lived in her rapt seclusion along with Sir Vincent—the critic, you know: their eyes fixed on the higher things, they disregarded maroons and had really a quite remarkable collection, by now, of first editions, official-titled friends and At Homes to their credit.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Yet Valentine remembered that once she had sat at the feet of the darkly mysterious Edith Ethel Duchemin—Where had ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" all ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("gone?—and had sympathised with her marital martyrdoms, her impressive taste in furniture, her large rooms and her spiritual adulteries. So she said good-humouredly to the instrument:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Aren’t you just the same, Edith Ethel? And what can I do for you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The good-natured patronage in her tone astonished her, and she was astonished, too, at the ease with which she spoke. Then she realised that the noises had been going away: silence was falling: the cries receded. They were going towards a cumulation at a distance. The girls’ voices in the playground no longer existed: the Head must have let them go. Naturally, too, the local population wasn’t going to go on letting off crackers in side streets…. She was alone: cloistered with the utterly improbable!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Lady Macmaster had sought her out and here was she, Valentine Wannop; patronising Lady Macmaster! Why? What could Lady Macmaster want her to do? She ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("couldn’t")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—But of course she jolly well could!—be thinking of being unfaithful to Macmaster and be wanting her, Valentine Wannop, to play the innocent, the virginal gooseberry or Disciple. Or alibi. Whatever it was. Goose was the most appropriate word…. Obviously Macmaster was the sort of person to whom any Lady Macmaster would want—would have—to be unfaithful. A little, dark-bearded, drooping, deprecatory fellow. A typical Critic! All Critic’s wives were probably unfaithful to them. They lacked the creative gift. What did you call it? A word unfit for a young lady to use!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Her mind ran about in this unbridled, Cockney school-girl’s vein. There was no stopping it. It was in honour of the DAY! She was temporarily inhibited from bashing policemen on the head, so she was mentally disrespectful to constituted authority—to Sir Vincent Macmaster, Principal Secretary to H.M. Department of Statistics, author of Walter Savage Lander, a Critical Monograph, and of twenty-two other Critical Monographs in the Eminent Bores’ Series…. ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Such")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" books! And she was being disrespectful and patronising to Lady Macmaster, Egeria to innumerable Scottish Men of Letters! No more respect! Was that to be a lasting effect of the cataclysm that had involved the world? The ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("late")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" cataclysm! Thank God, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("since ten minutes ago they could call it the late cataclysm!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She was positively tittering in front of the telephone from which Lady Macmaster’s voice was now coming in earnest, cajoling tones—as if she knew that Valentine was not paying very much attention, saying:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Valentine! ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Val")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("entine! ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Valentine!")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Valentine said negligently:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I’m listening!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She wasn’t really. She was really reflecting on whether there had not been more sense on the Mistress’s Conference that that morning, solemnly, had taken place in the Head’s private room. Undoubtedly what the Mistresses with the Head at their head had feared was that if they, Headmistresses, Mistresses, Masters, Pastors—by whom I was made etcetera!—should cease to be respected because saturnalia broke out on the sounding of a maroon the whole world would go to pieces! An awful thought! The Girls no longer sitting silent in the nonconformist hall while the Head addressed repressive speeches to them….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She had addressed a speech, containing the phrase: “the Credit of a Great Public School,” in that Hall only last afternoon in which, fair thin woman, square elbowed, with a little of sunlight really still in her coiled fair hair, she had seriously requested the Girls not again to repeat the manifestations of joy of the day before. The day before there had been a false alarm and the School—Horribly!—had sung:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Hang Kaiser Bill from the hoar apple tree"), _c('br'), _vm._v("And Glory Glory Glory till it’s tea-time!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Head, now, making her speech was certain that she had now before her a chastened School, a School that anyhow felt foolish because the rumour of the day before had turned out to be a canard. So she impressed on the Girls the nature of the joy they ought to feel: a joy repressed that should send them silent home. Blood was to cease to be shed: a fitting cause for home-joy—as it were a home-lesson. But there was to be no triumph. The very fact that you ceased hostilities precluded triumph….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Valentine, to her surprise, had found herself wondering when you ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("might")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" feel triumph? … You couldn")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’t whilst you were still contending: you must not when you had won! Then when? The Head told the girls that it was their province as the future mothers of England—Nay, of reunited Europe!—to—well, in fact, to go on with their home-lessons and not run about the streets with effigies of the Great Defeated! She put it that it was their function to shed further light of womanly culture—that there, Thank Heaven, they had never been allowed to forget!—athwart a re-illumined Continent…. As if you could light up now there was no fear of submarines or raids!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("And Valentine wondered why, for a mutinous moment, she had wanted to feel triumph … had wanted ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("someone")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" to feel triumph. Well, he … they … had wanted it so much. Couldn")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’t they have it just for a moment—for the space of one Benkollerdy! Even if it were wrong? or vulgar? Something human, someone had once said, is dearer than a wilderness of decalogues!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But at the Mistress’s Conference that morning, Valentine had realised that what was really frightening them was the other note. A quite definite fear. If, at this parting of the ways, at this crack across the table of History, the School—the World, the future mothers of Europe—got out of hand, would they ever come back? The Authorities—Authority all over the world—was afraid of that; more afraid of that than of any other thing. Wasn’t it a possibility that there was to be no more Respect? None for constituted Authority and consecrated Experience?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("And, listening to the fears of those careworn, faded, ill-nourished gentlewomen, Valentine Wannop had found herself speculating.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No more respect…. For the Equator! For the Metric system. For Sir Walter Scott! Or George Washington! Or Abraham Lincoln! Or the Seventh Commandment!!!!!!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("And she had a blushing vision of fair, shy, square-elbowed Miss Wanostrocht—the Head!—succumbing to some specious-tongued beguiler! … That was where the shoe really pinched! You had to keep them—the Girls, the Populace, everybody!—in hand now, for once you let go there was no knowing where They, like waters parted from the seas, mightn’t carry You. Goodness knew! You might arrive anywhere—at county families taking to trade; gentlefolk selling for profit! All the unthinkable sorts of things!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("And with a little inward smirk of pleasure Valentine realised that that Conference was deciding that the Girls were to be kept in the playground that morning—at Physical Jerks. She hadn’t ever put up with ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("much")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" in the way of patronage from the rather untidy-haired bookish branch of the establishment. Still, accomplished Classicist as she once had been, she had had to acknowledge that the bookish branch of a School was what you might call the Senior Service. She was there only to oblige—because her distinguished father had insisted on paying minute attention to her physique which was vital and admirable. She had been there, for some time past only to oblige—War Work and all that—but still she had always kept her place and had never hitherto raised her ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("voice at a Mistress’s Conference. So it was indeed the World Turned Upside Down—already!—when Miss Wanostrocht hopefully from behind her desk decorated with two pale pink carnations said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The idea is, Miss Wannop, that They should be kept—that you should keep them, please—as nearly as possible—isn’t it called?—at attention until the—eh—noises … announce the … well, ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("you")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" know. Then we suppose they will have to give, say, three cheers. And then perhaps you could get them—in an orderly way—back to their classrooms….")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Valentine felt that she was by no means certain that she ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("could")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(". It was not really practicable to keep every one of six hundred aligned girls under your eye. Still she was ready to have a shot. She was ready to concede that it might not be altogether—oh, expedient!—to turn six hundred girls stark mad with excitement into the streets already filled with populations that would no doubt be also stark mad with excitement. You had better keep them in if you could. She would have a shot. And she was pleased. She felt fit: amazingly fit! Fit to do the quarter in … oh, in any time! And to give a clump on the jaw to any large, troublesome Jewish type of maiden—or Anglo-Teutonic—who should try to break ranks. Which was more than the Head or any one of the other worried and underfed ones could do. She was pleased that they recognised it. Still she was also generous and recognising that the world ought not really to be turned upside down at any rate until the maroons went, she said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Of course I will have a shot at it. But it would be a reinforcement, in the way of keeping order, if the Head—you Miss Wanostrocht—and one or two others of the Mistresses would be strolling about. In relays, of course; not all of the staff all the morning …”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("That had been two and a half hours or so ago: before the world changed, the Conference having taken place at eight-thirty. Now here she was, after having kept those girls pretty exhaustingly jumping about for most of the intervening time—here she was treating with disrespect obviously constituted Authority. For whom ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ought")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" you to respect if not the wife of the Head of a Department, with a title, a country place and most highly attended Thursday afternoons?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She was not really listening to the telephone because Edith Ethel was telling her about the condition of Sir Vincent: so overworked, poor man, over Statistics that a nervous breakdown was imminently to be expected. Worried over money, too. Those dreadful taxes for this iniquitous affair….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Valentine took leisure to wonder why—why in the world!—Miss Wanostrocht who must know at the least the burden of Edith Ethel’s story had sent for her to hear this farrago? Miss Wanostrocht must know: she had obviously been talked to by Edith Ethel for long enough to form a judgment. Then the matter must be of importance. Urgent even, since the keeping of discipline in the playground was of such utter importance to Miss Wanostrocht: a crucial point in the history of the School and the mothers of Europe.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But to whom then could Lady Macmaster’s communication be of life and death importance? To her, Valentine Wannop? It could not be: there were no events of importance that could affect her life outside the playground, her mother safe at home and her brother safe on a mine-sweeper in Pembroke Dock….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then … of importance to Lady Macmaster herself? But how? What could she do for Lady Macmaster? Was she wanted to teach Sir Vincent to perform physical exercises so that he might avoid his nervous breakdown and, in excess of physical health, get the mortgage taken off his country place which she gathered was proving an overwhelming burden on account of iniquitous taxes the result of a war that ought never to have been waged?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It was absurd to think that she could be wanted for that! An absurd business…. There she was, bursting with health, strength, good-humour, perfectly ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("full")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" of beans—there she was, ready in the cause of order to give Leah Heldenstamm, the large girl, no end of a clump on the side of the jaw or, alternatively, for the sake of all the beanfeastishnesses in the world to assist in the amiable discomfiture of the police. There she was in a sort of noncomformist cloister. Nunlike! Positively nunlike! At the parting of the ways of the universe!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She whistled slightly to herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“By Jove,” she exclaimed coolly, “I hope it does not mean an omen that I’m to be—oh, nunlike—for the rest of my career in the reconstructed world!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She began for a moment seriously to take stock of her position—of her whole position in life. It had certainly been hitherto rather nunlike. She was twenty-threeish: rising twenty-four. As fit as a fiddle; as clean as a whistle. Five foot four in her gym shoes. And no one had ever wanted to marry her. No doubt that was because she was so clean and fit. No one even had ever tried to seduce her. That was ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("certainly")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" because she was so clean-run. She didn")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("’t obviously offer—What was it the fellow called it?—promise of pneumatic bliss to the gentlemen with sergeant-majors’ horse-shoe moustaches and gurglish voices! She never would. Then perhaps she would never marry. And never be seduced!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Nunlike! She would have to stand at an attitude of attention beside a telephone all her life; in an empty schoolroom with the world shouting from the playground. Or not even shouting from the playground any more. Gone to Piccadilly!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" … But, hang it all, she wanted some fun! Now!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("For years now she had been—oh, yes, nunlike!—looking after the lungs and limbs of the girls of the adenoidy, nonconformistish—really undenominational or so little Established as made no difference!—Great Public Girls’ School. She had had to worry about impossible but not repulsive little Cockney creatures’ breathing when they had their arms extended…. You ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("mustn’t")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" breathe rhythmically with your movements. No. No. ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("No!")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" … ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Don’t")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" breathe out with the first movement and in with the second! Breathe naturally! Look at me! … She breathed perfectly!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Well, for years that! War-work for a b—y Pro-German. Or Pacifist. Yes, that too she had been for years. She hadn’t liked being it because it was the attitude of the superior and she did not like being superior. Like Edith Ethel!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But now! Wasn’t it manifest? She could put her hand whole-heartedly into the hand of any Tom, Dick or Harry. And wish him luck! Wholeheartedly! Luck for himself and for his enterprise. She came back: into the fold: into the Nation even. She could open her mouth! She could let out the good little Cockney yelps that were her birthright. She could be free, independent!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Even her dear, blessed, muddle-headed, tremendously eminent mother by now had a depressed looking Secretary. She, Valentine Wannop, didn’t have to sit up all night typing after all day enjoining perfection of breathing in the playground…. By Jove they could go all, brother, mother in untidy black and mauve, secretary in untidy black without mauve, and she, Valentine, out of her imitation Girl Scout’s uniform and in—oh, white muslin or Harris tweeds—and with Cockney yawps discuss the cooking under the stone-pines of Amalfi. By the Mediterranean…. No one, then, would be able to say that she had never seen the sea of Penelope, the Mother of the Gracchi, Delia, Lesbia, Nausicaa, Sappho….")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Saepe te in somnis vidi!")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She said:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Good … ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("God!")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Not in the least with a Cockney intonation but like a good Tory English gentleman confronted by an unspeakable proposition. Well: it was an unspeakable proposition. For the voice from the telephone had been saying to her inattention, rather crawlingly, after no end of details as to the financial position of the house of Macmaster:")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“So I thought, my dear Val, in remembrance of old times; that … If in short I were the means of bringing you together again…. For I believe you have not been corresponding…. You might in return…. You can see for yourself that at this moment the sum would be absolutely ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("crushing")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("….”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775377f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled120.vue
// module id = 75
// module chunks = 0